export const BEFORE_PURCHASE = 'BEFORE_PURCHASE';
export const DURING_PURCHASE = 'DURING_PURCHASE';
export const PROPOSALS_READY = 'PROPOSALS_READY';
export const CLEAR_PROPOSALS = 'CLEAR_PROPOSALS';
export const PURCHASE_SUCCESSFUL = 'PURCHASE_SUCCESSFUL';
export const OPEN_CONTRACT = 'OPEN_CONTRACT';
export const INVALID_ACTION = 'INVALID_ACTION';
export const SELL = 'SELL';
export const START = 'START';
export const STOP = 'STOP';
export const NEW_TICK = 'NEW_TICK';



// WEBPACK FOOTER //
// ./src/botPage/bot/TradeEngine/state/constants.js